import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props
import { IPaginationResourceShort } from '../../../../../props/general';

// components
import { ActionButton, CommandBar, IColumn, ICommandBarItemProps, IContextualMenuItem, Persona, PrimaryButton, SearchBox, SelectionMode, ShimmeredDetailsList, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';
import KeyForm from '../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';
import GeneralService from '../../../../../services/general';
import GlobalConfig from '../../../../../config';
import { IPublicKeyResourceShort } from '../../../../../props/data/key';
import KeyService from '../../../../../services/data/keys';
import { PublicKeyTypes } from '../../../../../manifests/PublicKeyTypes';

interface IKeysListProps {
}

const KeysList: React.FC<IKeysListProps> = (props: IKeysListProps) => {
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [showingMore, setShowingMore] = React.useState<boolean>(false);
    const [keys, setKeys] = React.useState<IPublicKeyResourceShort[]>([]);
    const [activeKey, setActiveKey] = React.useState<IPublicKeyResourceShort | undefined>();
    const [pagination, setPagingation] = React.useState<IPaginationResourceShort | undefined>();
    const [keyword, setKeyword] = React.useState<string>("");
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    const columns: IColumn[] = [
        {
            key: 'name',
            name: 'Name',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicKeyResourceShort) => {
                return (
                    <Stack>
                        <Text>{PublicKeyTypes.find(f => f.key === item.name)?.text}</Text>
                    </Stack>
                );
            },
        },
        {
            key: 'key',
            name: 'Key',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicKeyResourceShort) => {
                return (
                    <Stack>
                        <Text>{item.key}</Text>
                    </Stack>
                );
            },
        },
        {
            key: "actions",
            name: "",
            minWidth: 50,
            maxWidth: 50,
            onRender: (item: IPublicKeyResourceShort) => {
                let menuItems: IContextualMenuItem[] = [
                    {
                        key: "update", text: "Update details", iconProps: { iconName: "Edit" }, onClick: () => {
                            setActiveKey(item);
                            setActiveSurface('update');
                        },
                    },
                    {
                        key: "delete",
                        text: "Delete",
                        iconProps: { iconName: "Delete" },
                        onClick: () => {
                            onDelete(item)
                        },
                    }
                ];

                return (
                    <Stack.Item styles={{ root: { padding: '2px 0px' } }}>
                        <Stack.Item className={"detailsListActionRow"}>
                            <ActionButton className={'detailsListActionButton'} menuProps={{
                                items: menuItems
                            }} />
                        </Stack.Item>
                    </Stack.Item>
                );
            }
        },
    ];

    const onDelete = async (item: IPublicKeyResourceShort) => {
        if (window.confirm(`Hapus ${item.name}?`)) {
            setKeys([...keys.filter(f => f.id !== item.id)])
            try {
                await KeyService.delete(item.id)
            } catch (error) {
            }
        }
    }

    useEffect(() => {
        _onRetrieveKeys();
    }, []);

    useEffect(() => {
        _onRetrieveKeys();
    }, [keyword]);

    const _onRetrieveKeys = async (pageNumber?: number,) => {
        const qs: string[] = [];
        if (pageNumber) { qs.push(`page=${pageNumber}`); }
        if (keyword && keyword.trim() !== "") { qs.push(`search=${keyword}`) }
        try {
            const items = await KeyService.retrieve(qs.join("&"))
            setKeys(items)

            setPagingation(undefined);
            setLoaded(true);
        } catch (error) {

        }
    }

    const _onKeywordChanged = (value?: string) => {
        setLoaded(true);
        setKeyword(value || "");
    }

    const getCommandBarItems = () => {
        let items: ICommandBarItemProps[] = [];
        let farItems: ICommandBarItemProps[] = [];

        items.push({
            key: "search",
            onRender: () => {
                return <SearchBox placeholder={"Search ..."} onSearch={_onKeywordChanged} />
            }
        });

        farItems.push({
            key: "register",
            text: "Create Key",
            iconProps: { iconName: "Add" },
            onRender: () => {
                return <PrimaryButton text={"Create Key"}
                    iconProps={{ iconName: "Add" }}
                    onClick={() => { setActiveSurface('create') }}
                    styles={{ root: { marginLeft: 10 } }} />;
            }
        });

        return { items, farItems };
    }

    const _onSurfaceDismissed = (refresh?: boolean) => {
        setActiveSurface(undefined);
        setActiveKey(undefined);

        if (refresh) { _onRetrieveKeys() }
    }

    return <Stack className={styles.container} tokens={{ childrenGap: 20 }}>
        <CommandBar
            items={getCommandBarItems().items}
            farItems={getCommandBarItems().farItems}
            styles={{
                root: {
                    padding: 0,
                    height: 'unset',
                    backgroundColor: 'transparent'
                }
            }}
            ariaLabel="Use left and right arrow keys to navigate between commands" />
        <Stack className={styles.list}>
            {
                !loaded || (loaded && keys.length > 0) ? (
                    <>
                        <ShimmeredDetailsList
                            setKey="items"
                            items={keys}
                            columns={columns}
                            selectionMode={SelectionMode.none}
                            enableShimmer={!loaded}
                            onShouldVirtualize={() => false}
                            ariaLabelForShimmer="Content is being fetched"
                            ariaLabelForGrid="Item details" />
                    </>
                ) : null
            }
            {loaded && keys.length < 1 ? <Stack styles={{ root: { padding: 10 } }}>
                <Text>Key(s) not found</Text>
            </Stack> : null}
        </Stack>
        {activeSurface === 'create' ? <KeyForm onDismissed={_onSurfaceDismissed} /> : null}
        {activeSurface === 'update' && activeKey ? <KeyForm keyId={activeKey.id} onDismissed={_onSurfaceDismissed} /> : null}
    </Stack>;
};

export default KeysList;
